import { AxiosInstance } from 'axios';
import * as RoomStateReportService from './services';

export type RoomStateReportServiceType = ReturnType<typeof RoomStateReportService.exportPDF>;

export const initRoomStateReportService = (axios: AxiosInstance): RoomStateReportServiceType =>
  RoomStateReportService.exportPDF(axios);
